var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultQuestionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9125 17.5C8.58251 18.3567 10.5036 18.5888 12.3295 18.1543C14.1555 17.7199 15.7662 16.6476 16.8715 15.1307C17.9768 13.6138 18.504 11.7519 18.358 9.88068C18.212 8.00945 17.4025 6.25189 16.0753 4.92471C14.7482 3.59753 12.9906 2.78801 11.1194 2.64203C9.24813 2.49605 7.38629 3.02321 5.86934 4.12851C4.3524 5.23381 3.28011 6.84456 2.84569 8.67051C2.41128 10.4965 2.64332 12.4175 3.5 14.0875L1.75 19.25L6.9125 17.5Z",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.95312 7.87501C8.15884 7.29022 8.56488 6.7971 9.09934 6.483C9.63379 6.1689 10.2622 6.05408 10.8732 6.15888C11.4842 6.26369 12.0383 6.58134 12.4376 7.0556C12.8368 7.52985 13.0553 8.13009 13.0544 8.75001C13.0544 10.5 10.4294 11.375 10.4294 11.375M10.4994 14.875H10.5081",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultQuestionIcon);
export default __webpack_public_path__ + "static/media/default-question-icon.366f58048b2c1186f71b0bfdabc2bf6f.svg";
export { ForwardRef as ReactComponent };